<template>
  <div class="page-box news-info-box">
    <div class="content-block">
      <el-breadcrumb  separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home/news/list' }">官方资讯</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">{{newsInfo.title}}</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content" v-loading="loading">
      <div class="title-box">
        <h3 class="title">
          {{newsInfo.title}}
        </h3>
        <p class="subhead">
          <span class="type">{{newsInfo.type | newsType()}}</span>
          {{newsInfo.publishTime | parseTime()}}
        </p>
      </div>
      <div id="html" v-html="newsInfo.content"></div>
      <Voting v-if="newsInfo.type==2" :newsInfo="newsInfo"></Voting>
      <Activity v-if="newsInfo.type==3" :newsInfo="newsInfo"></Activity>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5';
import { singleNewsSever } from "@/common/api-config";
import Voting from "./template/Voting";
import Activity from "./template/Activity";

export default {
  components: { Voting, Activity},
  created() {
    this.newsId=this.$route.query.newsId;
    this.statistics(); //统计PU,UV
    this.queryNewsInfo(); //获取新闻详情
  },
  mounted(){
    $('#baseCss').remove();
  },
  //离开当前页面后执行
  destroyed () {
    $('head').prepend(`<link rel="stylesheet" href="${process.env.BASE_URL}base.css" id="baseCss">`);
  },
  data() {
    return {
      baseCss:null,
      loading: false,
      newsId:'',
      newsInfo:{},
    };
  },
  methods: {
    //统计PU,UV
    statistics(){
      /* 参数msd加密用作签名*/
      let now =Date.now();//时间戳
      let json = this.utils.sort_ASCII( //ASCII码从小到大排序
        {
          url: this.$route.fullPath,
          uuid: this.$cookies.get('uuid'),
          timestamp:now,
        }
      );
      let paramStr=decodeURIComponent(this.utils.jsonToParamStr(json));//转成拼接参数（timestamp=1616061217031&url=/home/news/info&uuid=Fo05gxOIAXOh3qen8Km3W）
      let sign = md5('6be5d785366eac0bc511c8ff3b0e0721'+md5(paramStr));//MD5加密
      singleNewsSever.statistics({
        url: this.$route.fullPath,//	必填	string	页面地址
        uuid: this.$cookies.get('uuid'),//	必填	string	用户标识
        timestamp:now,//	必填	int	时间戳
        sign: sign,//	必填	string	签名
      })
      .then((res) => {});
    },
    //获取新闻详情
    queryNewsInfo(){
      this.loading = true;
      singleNewsSever.queryNewsInfo({
        id: this.newsId,//	string	资讯id
        uuid: this.$cookies.get('uuid'),//	string	cookieId	唯一标识
      })
      .then((res) => {
        if (res.code == 0) {
          this.newsInfo = res.data;
          this.loading = false;
          this.$nextTick(() => {
            prismjs.highlightAll()
          });
        } else {
          this.$message.error(res.message);
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
.news-info-box {
  padding-bottom: 32px;
  .content-block{
    padding: 20px 0;
  }
  .content {
    margin: auto;
    width: 1240px;
    padding: 50px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(150, 188, 255, 0.25);
    .title-box{
      border-bottom: 1px solid #DCDFE6;
      .title{
        font-size: 30px;
        font-weight: bold;
        color: #333333;
        text-align: center;
      }
      .subhead{
        margin: 30px 0;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        text-align: center;
        .type{
          margin-right: 20px;
        }
      }
    }
    /deep/ #html{
      padding: 20px 0;
      html, address,blockquote,body, dd, div,dl, dt, fieldset, form,frame, frameset,h1, h2, h3, h4,h5, h6, noframes,ol, p, ul, center,dir, hr, menu, pre   { display: block; unicode-bidi: embed }li              { display: list-item }head            { display: none }table           { display: table }tr              { display: table-row }thead           { display: table-header-group }tbody           { display: table-row-group }tfoot           { display: table-footer-group }col             { display: table-column }colgroup        { display: table-column-group }td, th          { display: table-cell }caption         { display: table-caption }th              { font-weight: bolder; text-align: center }caption         { text-align: center }body            { margin: 8px }h1              { font-size: 2em; margin: .67em 0 }h2              { font-size: 1.5em; margin: .75em 0 }h3              { font-size: 1.17em; margin: .83em 0 }h4, p,blockquote, ul,fieldset, form,ol, dl, dir,menu            { margin: 1.12em 0 }h5              { font-size: .83em; margin: 1.5em 0 }h6              { font-size: .75em; margin: 1.67em 0 }h1, h2, h3, h4,h5, h6, b,strong          { font-weight: bolder }blockquote      { margin-left: 40px; margin-right: 40px }i, cite, em,var, address    { font-style: italic }pre, tt, code,kbd, samp       { font-family: monospace }pre             { white-space: pre }button, textarea,input, select   { display: inline-block }big             { font-size: 1.17em }small, sub, sup { font-size: .83em }sub             { vertical-align: sub }sup             { vertical-align: super }table           { border-spacing: 2px; }thead, tbody,tfoot           { vertical-align: middle }td, th, tr      { vertical-align: inherit }s, strike, del  { text-decoration: line-through }hr              { border: 1px inset }ol, ul, dir,menu, dd        { margin-left: 40px }ol              { list-style-type: decimal }ol ul, ul ol,ul ul, ol ol    { margin-top: 0; margin-bottom: 0 }u, ins          { text-decoration: underline }br:before       { content: "\A"; white-space: pre-line }center          { text-align: center }:link, :visited { text-decoration: underline }:focus          { outline: thin dotted invert }/* Begin bidirectionality settings (do not change) */BDO[DIR="ltr"]  { direction: ltr; unicode-bidi: bidi-override }BDO[DIR="rtl"]  { direction: rtl; unicode-bidi: bidi-override }*[DIR="ltr"]    { direction: ltr; unicode-bidi: embed }*[DIR="rtl"]    { direction: rtl; unicode-bidi: embed }@media print {
      h1            { page-break-before: always }

      h1, h2, h3,

      h4, h5, h6    { page-break-after: avoid }

      ul, ol, dl    { page-break-before: avoid;
      }}
      pre[class*="language-"]{
        border:0;
        box-shadow:none;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .news-info-box {
    width: 100%;
    .content-block{
    }
    .content {
      width: 100%;
      padding: 10px 0;
    }
  }
}
  ul{
      list-style:disc;
    }
</style>

